document.addEventListener('DOMContentLoaded', function () {
  const productGrid = document.querySelector('#product-grid');

  if (!productGrid) return;

  const query =
    new URLSearchParams(window.location.search).get('q');

  if (!query) return;

  const originalList =
    productGrid.querySelector('ul');

  if (!originalList) return;


  /* =========================
     Search
  ========================= */

  async function getResults(type, page = 1) {

    const url =
      '/search?q=' +
      encodeURIComponent(query) +
      '&type=' +
      type +
      '&page=' +
      page +
      '&options%5Bprefix%5D=last';

    const response =
      await fetch(url);

    if (!response.ok) {
      throw new Error('Search request failed');
    }

    const html =
      await response.text();

    return new DOMParser()
      .parseFromString(html, 'text/html');
  }


  function getList(doc) {
    return doc.querySelector(
      '#product-grid ul'
    );
  }


  function getPagination(doc) {
    return (
      doc.querySelector(
        '#product-grid .pagination-wrapper'
      ) ||
      doc.querySelector(
        '#product-grid .pagination'
      )
    );
  }


  /* =========================
     Get Last Page
  ========================= */

  function getLastPage(doc) {

    const pagination =
      getPagination(doc);

    if (!pagination) {
      return 1;
    }

    const links =
      pagination.querySelectorAll('a');

    let lastPage = 1;

    links.forEach(function (link) {

      const url =
        new URL(
          link.href,
          window.location.origin
        );

      const page =
        parseInt(
          url.searchParams.get('page'),
          10
        );

      if (
        !isNaN(page) &&
        page > lastPage
      ) {
        lastPage = page;
      }

    });

    return lastPage;
  }


  /* =========================
     Pagination
  ========================= */

  function setupPagination(
    type,
    section,
    doc
  ) {

    const paginationArea =
      section.querySelector(
        '.search-pagination'
      );

    const originalPagination =
      getPagination(doc);

    if (!originalPagination) {
      paginationArea.innerHTML = '';
      return;
    }

    paginationArea.innerHTML =
      originalPagination.innerHTML;

    paginationArea
      .querySelectorAll('a')
      .forEach(function (link) {

        link.addEventListener(
          'click',
          function (event) {

            event.preventDefault();

            const url =
              new URL(
                link.href,
                window.location.origin
              );

            const page =
              url.searchParams.get(
                'page'
              ) || 1;

            loadPage(
              type,
              section,
              page
            );
          }
        );
      });
  }


  async function loadPage(
    type,
    section,
    page
  ) {

    const list =
      section.querySelector('ul');

    try {

      const doc =
        await getResults(
          type,
          page
        );

      const results =
        getList(doc);

      if (!results) return;

      list.innerHTML =
        results.innerHTML;

      setupPagination(
        type,
        section,
        doc
      );

      section.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

    } catch (error) {

      console.error(
        'Search page error:',
        error
      );
    }
  }


  /* =========================
     STYLE Carousel
  ========================= */

  function makeStyleCarousel(section) {

    const list =
      section.querySelector('ul');

    if (!list) return;

    list.classList.add(
      'style-carousel-list'
    );

    const wrapper =
      document.createElement('div');

    wrapper.className =
      'style-carousel-wrapper';

    const prevButton =
      document.createElement('button');

    prevButton.type = 'button';

    prevButton.className =
      'style-carousel-button style-carousel-prev';

    prevButton.setAttribute(
      'aria-label',
      'Previous'
    );

    prevButton.innerHTML = '‹';


    const nextButton =
      document.createElement('button');

    nextButton.type = 'button';

    nextButton.className =
      'style-carousel-button style-carousel-next';

    nextButton.setAttribute(
      'aria-label',
      'Next'
    );

    nextButton.innerHTML = '›';


    list.parentNode.insertBefore(
      wrapper,
      list
    );

    wrapper.appendChild(
      prevButton
    );

    wrapper.appendChild(
      list
    );

    wrapper.appendChild(
      nextButton
    );


    function updateButtons() {

      const maxScroll =
        list.scrollWidth -
        list.clientWidth;

      prevButton.disabled =
        list.scrollLeft <= 5;

      nextButton.disabled =
        list.scrollLeft >=
        maxScroll - 5;
    }


    prevButton.addEventListener(
      'click',
      function () {

        list.scrollBy({
          left: -list.clientWidth,
          behavior: 'smooth'
        });
      }
    );


    nextButton.addEventListener(
      'click',
      function () {

        list.scrollBy({
          left: list.clientWidth,
          behavior: 'smooth'
        });
      }
    );


    list.addEventListener(
      'scroll',
      updateButtons
    );

    window.addEventListener(
      'resize',
      updateButtons
    );

    updateButtons();
  }


  /* =========================
     Load ALL STYLE Results
  ========================= */

  async function loadAllStyleResults(
    section,
    firstDoc
  ) {

    const firstResults =
      getList(firstDoc);

    if (
      !firstResults ||
      !firstResults.children.length
    ) {
      section.remove();
      return false;
    }


    const list =
      section.querySelector('ul');


    /* 1ページ目 */
    list.innerHTML =
      firstResults.innerHTML;


    /* 最終ページを取得 */
    const lastPage =
      getLastPage(firstDoc);


    /* 2ページ目以降 */
    if (lastPage > 1) {

      const pageRequests = [];

      for (
        let page = 2;
        page <= lastPage;
        page++
      ) {

        pageRequests.push(
          getResults(
            'article',
            page
          )
        );

      }


      const pages =
        await Promise.all(
          pageRequests
        );


      pages.forEach(function (doc) {

        const results =
          getList(doc);

        if (
          !results ||
          !results.children.length
        ) {
          return;
        }

        list.insertAdjacentHTML(
          'beforeend',
          results.innerHTML
        );

      });
    }


    /* STYLEはページネーション不要 */
    const pagination =
      section.querySelector(
        '.search-pagination'
      );

    if (pagination) {
      pagination.remove();
    }


    /* 全件読み込み後にカルーセル化 */
    makeStyleCarousel(
      section
    );


    return true;
  }


  /* =========================
     Initial Results
  ========================= */

  async function loadInitialResults(
    type,
    section
  ) {

    try {

      const doc =
        await getResults(
          type,
          1
        );

      const results =
        getList(doc);

      if (
        !results ||
        !results.children.length
      ) {

        section.remove();

        return false;
      }


      if (type === 'article') {

        return await loadAllStyleResults(
          section,
          doc
        );

      }


      /* PRODUCTS */

      section
        .querySelector('ul')
        .innerHTML =
        results.innerHTML;


      setupPagination(
        type,
        section,
        doc
      );


      return true;

    } catch (error) {

      console.error(
        'Search loading error:',
        error
      );

      section.remove();

      return false;
    }
  }


  /* =========================
     Create Sections
  ========================= */

  const container =
    document.createElement('div');

  container.innerHTML = `

    <section
      class="search-section search-section-products"
    >
      <h2 class="h2">
        PRODUCTS
      </h2>

      <ul
        class="${originalList.className}"
        role="list"
      ></ul>

      <div
        class="search-pagination"
      ></div>
    </section>


    <section
      id="style-results"
      class="search-section search-section-articles"
    >
      <h2 class="h2">
        STYLE
      </h2>

      <ul
        class="${originalList.className}"
        role="list"
      ></ul>

      <div
        class="search-pagination"
      ></div>
    </section>

  `;


  const productsSection =
    container.querySelector(
      '.search-section-products'
    );

  const articlesSection =
    container.querySelector(
      '.search-section-articles'
    );


  originalList.replaceWith(
    container
  );


  productGrid
    .querySelectorAll(
      '.pagination-wrapper, .pagination'
    )
    .forEach(function (pagination) {

      pagination.remove();

    });


  /* =========================
     Load PRODUCTS
  ========================= */

  loadInitialResults(
    'product',
    productsSection
  );


  /* =========================
     Load STYLE
  ========================= */

  loadInitialResults(
    'article',
    articlesSection
  ).then(function (styleExists) {

    if (!styleExists) return;


    /* =========================
       Smooth Scroll Link
    ========================= */

    function createStyleLink() {

      const styleLink =
        document.createElement('a');

      styleLink.href =
        '#style-results';

      styleLink.textContent =
        '着こなしを見る';

      styleLink.className =
        'search-style-link';

      styleLink.addEventListener(
        'click',
        function (event) {

          event.preventDefault();

          const styleSection =
            document.querySelector(
              '#style-results'
            );

          if (!styleSection) return;

          styleSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

        }
      );

      return styleLink;
    }


 /* =========================
   PC / Mobile
========================= */

const isMobile =
  window.innerWidth <= 749;


/* =========================
   PC
========================= */

if (!isMobile) {

  const desktopFilter =
    document.querySelector(
      '#FacetsWrapperDesktop.facets__wrapper'
    );

  if (desktopFilter) {

    desktopFilter.appendChild(
      createStyleLink()
    );

  }

}


/* =========================
   Mobile
========================= */

if (isMobile) {

  const mobileSearch =
    document.querySelector(
      '.template-search__search'
    );

  if (mobileSearch) {

    mobileSearch.parentNode.insertBefore(
      createStyleLink(),
      mobileSearch.nextSibling
    );

  }

}

  });

});